import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Input,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import InputText from "../../../common/forms/InputText";
import SelectOption from "../../../common/forms/SelectOption";

const maritalStatuses = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
].map((status) => ({ id: status, name: status }));

function NfcApplicationForm({
  formData,
  submitLoading,
  editingApplication,
  onSubmit,
  onCancel,
  onFileChange,
  onFieldChange,
}) {
  const isBankDetailsUpdate = editingApplication?.paid === 1;
  const fieldPrefix = editingApplication?.id || "new";

  return (
    <Card className="mb-8 w-full">
      <form onSubmit={onSubmit}>
        <CardBody>
          <Typography variant="h5" color="black" className="mb-6">
            {isBankDetailsUpdate
              ? "Update Bank Account Details"
              : editingApplication
                ? "Edit NFC Identification Card Application"
                : "Apply for NFC Identification Card"}
          </Typography>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {!isBankDetailsUpdate && (
              <div>
                <InputText
                  key={`${fieldPrefix}-ghana-card-number`}
                  labelTitle="Ghana Card Number"
                  defaultValue={formData.ghana_card_number}
                  updateType="ghana_card_number"
                  updateFormValue={onFieldChange}
                  required
                />
                <Typography
                  variant="small"
                  color="gray"
                  className="mt-2 flex items-center gap-1 font-normal"
                >
                  Please provide Ghana Card number in this format:
                  GHA-123456789-0
                </Typography>
              </div>
            )}

            {!isBankDetailsUpdate && (
              <div className="flex flex-col gap-2">
                <Input
                  color="black"
                  type="file"
                  label="Profile Image"
                  variant="static"
                  accept="image/*"
                  onChange={(event) => onFileChange(event.target.files?.[0] || null)}
                  disabled={submitLoading}
                  required={!editingApplication?.passport_photo}
                />
                <Typography
                  variant="small"
                  color="black"
                  className="flex items-center gap-1 font-normal"
                >
                  {editingApplication?.passport_photo
                    ? "Upload a new profile image only if you want to replace the current one."
                    : "Upload a clear profile image before making payment."}
                </Typography>
              </div>
            )}

            <SelectOption
              key={`${fieldPrefix}-marital-status`}
              labelTtile="Marital Status"
              defaultValue={formData.marital_status}
              updateType="marital_status"
              updateFormValue={onFieldChange}
              children={maritalStatuses}
              required
            />

            <InputText
              key={`${fieldPrefix}-gps-address`}
              labelTitle="GPS Address"
              defaultValue={formData.gps_address}
              updateType="gps_address"
              updateFormValue={onFieldChange}
              maxLength={255}
              required
            />
          </div>

          <div className="flex flex-col sm:flex-row gap-3 my-8">
            <InputText
              key={`${fieldPrefix}-next-of-kin-name`}
              labelTitle="Next of Kin Name"
              defaultValue={formData.next_of_kin_name}
              updateType="next_of_kin_name"
              updateFormValue={onFieldChange}
              maxLength={150}
              required
            />
            <InputText
              key={`${fieldPrefix}-next-of-kin-contact`}
              labelTitle="Next of Kin Contact"
              defaultValue={formData.next_of_kin_contact}
              updateType="next_of_kin_contact"
              updateFormValue={onFieldChange}
              maxLength={50}
              required
            />
            <InputText
              key={`${fieldPrefix}-next-of-kin-relationship`}
              labelTitle="Next of Kin Relationship"
              defaultValue={formData.next_of_kin_relationship}
              updateType="next_of_kin_relationship"
              updateFormValue={onFieldChange}
              maxLength={100}
              required
            />
          </div>
        </CardBody>

        <CardFooter className="flex flex-col sm:flex-row gap-3">
          <Button type="submit" color="blue-gray" disabled={submitLoading}>
            {submitLoading ? <Spinner className="h-4 w-4" /> : "Submit Details"}
          </Button>

          {editingApplication && (
            <Button
              type="button"
              variant="outlined"
              color="blue-gray"
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
        </CardFooter>
      </form>
    </Card>
  );
}

export default NfcApplicationForm;
